import {BaseAlert} from "base/error/model";
import {permit_view_adapter} from "permit/model";
import {PermitApplicationService} from "permitapplication/service";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";
import {FileUpload} from "base/file/utilities";

const usePermitApplicationForm = (permit, basePath, fileFields) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const handleFormSubmit = (updatedPermit, callback = null) => {
        const objectContainsFiles = FileUpload.objectContainsFiles(updatedPermit);

        if (!objectContainsFiles) {
            updatePermitApplication(updatedPermit).then(() => {
                FileUpload.callCallback(callback, true);
                navigate(basePath, true);
            });
        } else {
            const objectContainsDuplicateFiles =
                FileUpload.objectContainsDuplicateFiles(updatedPermit);
            if (objectContainsDuplicateFiles) {
                const error = new BaseAlert(
                    "error",
                    "Não é permitido selecionar o mesmo ficheiro em mais de um campo."
                );
                handleErrors(error);
                FileUpload.callCallback(callback, false);
                return;
            }

            FileUpload.uploadFiles(updatedPermit, permit, fileFields)
                .then(fileUploadResults => {
                    FileUpload.updateFormWithFileIds(
                        updatedPermit,
                        fileUploadResults,
                        fileFields
                    );
                    return updatePermitApplication(updatedPermit);
                })
                .then(() => {
                    FileUpload.callCallback(callback, true);
                    navigate(basePath, true);
                })
                .catch(fileError => {
                    FileUpload.callCallback(callback, false);
                    handleErrors(fileError.error);
                });
        }
    };

    const updatePermitApplication = updatedPermit => {
        return PermitApplicationService.update(
            permit_view_adapter(updatedPermit)
        ).catch(error => {
            handleErrors(error);
        });
    };

    return {
        handleFormSubmit,
    };
};

export {usePermitApplicationForm};
